// src/components/auth/ProtectedRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token = localStorage.getItem('adminToken'); // or sessionStorage, depending on your setup

  return token ? <>{children}</> : <Navigate to="/admin/login" replace />;
};

export default ProtectedRoute;